export const GET_SHEET = 'GET_SHEET';
export const GET_SHEET_SUCCESS = 'GET_SHEET_SUCCESS';
export const GET_SHEET_ERROR = 'GET_SHEET_ERROR';
export const SET_SHEET = 'SET_SHEET';

export const GET_INTEGRATION = 'GET_INTEGRATION';
export const GET_INTEGRATION_SUCCESS = 'GET_INTEGRATION_SUCCESS';
export const GET_INTEGRATION_ERROR = 'GET_INTEGRATION_ERROR';
